// ===================================================================
// MAINSTREET — Module Layout with sub-navigation
// Private Sector Coordination — tab-based navigation
// ===================================================================

import { Outlet, useLocation } from 'react-router-dom';
import {
  IconLayoutDashboard, IconBuilding, IconBuildingWarehouse,
  IconAddressBook, IconMessage, IconClipboardCheck,
  IconAlertTriangle, IconPackage, IconList,
  IconShieldCheck, IconMap, IconChartBar, IconFileText,
  IconHome, IconScan,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import ModuleNav from '../../components/layout/ModuleNav';
import { useRoleStore } from '../../store/roleStore';
import type { NavItem } from '../../types/nav';
import BusinessPortalLayout from './portal/BusinessPortalLayout';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
// brand color handled by ModuleNav

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/mainstreet', icon: IconLayoutDashboard, exact: true },
  { label: 'My Business', path: '/mainstreet/my-business', icon: IconHome, visibleToSlugs: ['biz_owner'] },
  { label: 'Organizations', path: '/mainstreet/organizations', icon: IconBuilding, hiddenFromSlugs: ['biz_owner'] },
  { label: 'Facilities', path: '/mainstreet/facilities', icon: IconBuildingWarehouse, hiddenFromSlugs: ['biz_owner'] },
  { label: 'Contacts', path: '/mainstreet/contacts', icon: IconAddressBook, hiddenFromSlugs: ['biz_owner'] },
  { label: 'Feed', path: '/mainstreet/feed', icon: IconMessage },
  { label: 'Status', path: '/mainstreet/status', icon: IconClipboardCheck },
  { label: 'Damage', path: '/mainstreet/damage', icon: IconAlertTriangle },
  { label: 'Resources', path: '/mainstreet/resources', icon: IconPackage },
  { label: 'Lists', path: '/mainstreet/lists', icon: IconList, minLevel: 'editor' },
  { label: 'Re-entry', path: '/mainstreet/reentry', icon: IconShieldCheck },
  { label: 'Checkpoint', path: '/mainstreet/checkpoint', icon: IconScan },
  { label: 'Map', path: '/mainstreet/map', icon: IconMap, minLevel: 'editor' },
  { label: 'Analytics', path: '/mainstreet/analytics', icon: IconChartBar, minLevel: 'editor' },
  { label: 'Reports', path: '/mainstreet/reports', icon: IconFileText, minLevel: 'editor' },
];

export default function MainStreetLayout() {
  const { pathname } = useLocation();
  const myRole = useRoleStore(s => s.myRole);
  const visibleItems = useFilteredNav('mainstreet', NAV_ITEMS);

  // Business owners get a dedicated portal layout
  if (myRole?.roleSlug === 'biz_owner') {
    return <BusinessPortalLayout />;
  }

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      <Breadcrumbs
        items={[
          { label: 'Hub', to: '/' },
          { label: 'MainStreet', to: '/mainstreet' },
          ...(currentPage && currentPage.path !== '/mainstreet' ? [{ label: currentPage.label }] : []),
        ]}
      />
      <ModuleNav items={visibleItems} />
      <Outlet />
    </div>
  );
}
